import Pattern from '../ASSETS/PairanoiaPattern.png';

export const GradientBackground = `radial-gradient(transparent, black 100%), url(${Pattern})`;
export const NoGradientBackground = `url(${Pattern})`;
